import { render, staticRenderFns } from "./ExtraDocumentSelectorDialog.vue?vue&type=template&id=6e109e8b&"
import script from "./ExtraDocumentSelectorDialog.vue?vue&type=script&lang=ts&"
export * from "./ExtraDocumentSelectorDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports